import { ECampaign } from '@/shared/enum/campaign.enum'
import { ECountry } from '@/shared/enum/country.enum'

export const isRedirectPackages = (campaign: ECampaign, country: ECountry) => {
  return campaign.toUpperCase() === ECampaign.RECHARGE && country === ECountry.GT
}
